export const formatCPF = (value: string) => {
  if (value.length === 10) {
    value = '0' + value;
  }

  value = value.replace(/[^0-9]/g, '').substr(0, 11);
  if (value.length > 3) {
    value = `${value.substr(0, 3)}.${value.substr(3, value.length)}`;
  }

  if (value.length > 7) {
    value = `${value.substr(0, 7)}.${value.substr(7, value.length)}`;
  }

  if (value.length > 11) {
    value = `${value.substr(0, 11)}-${value.substr(11, value.length)}`;
  }
  return value;
};
